import React from 'react'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  name: string
  id: string
  toggleSize?: 'sm' | 'md'
}
const ToggleButton: React.FC<Props> = ({ label, toggleSize = 'md', ...rest }) => {
  return (
    <label htmlFor={rest.id} className='flex items-center cursor-pointer'>
      <div className='relative'>
        <input
          type='checkbox'
          className='sr-only'
          {...rest}
        />
        <div className={`block ${toggleSize === 'sm' ? 'w-8 h-5 sm:w-10 sm:h-6' : 'w-10 h-6 sm:w-14 sm:h-8'} rounded-full ${
          rest.checked ? 'bg-deep-green' : 'bg-gray'
        } transition-colors duration-300 ease-in-out`}></div>
        <div className={`absolute left-1 top-1 bg-white ${toggleSize === 'sm' ? 'w-3 h-3 sm:w-4 sm:h-4' : 'w-4 h-4 sm:w-6 sm:h-6'} rounded-full transition-transform duration-300 ease-in-out ${
          rest.checked ? 'transform translate-x-full' : ''
        }`}></div>
      </div>
      <div className={`ml-3 ${toggleSize === 'sm' ? 'text-2xs sm:text-xs' : 'text-xs sm:text-sm'} `}>
        {label}
      </div>
    </label>
  )
}

export default ToggleButton
